import { useEffect, useState } from 'react';
import { getUser } from 'utils/cartHelpers';
import ewAnalytics from 'utils/analytics';
import { useLDClient } from 'gatsby-plugin-launchdarkly';
import { defaultUser } from './context';
import { logError } from '../../helpers';

export const useUserContext = () => {
  const [userData, setUserData] = useState(defaultUser);
  const ldClient = useLDClient();

  const runEffect = async (
    viewEventId?: string | undefined,
    productId?: number | undefined,
  ) => {
    try {
      const data = await getUser(viewEventId, productId);
      const sessionData = data ? data.data : {};
      const {
        logged_in: loggedIn,
        is_member: isMember,
        membership_type: membershipType,
        active_credits: activeCredits,
        user_id: userId,
        user_email: userEmail,
        next_credit_date: nextCreditDate,
        first_name: firstName,
        last_name: lastName,
        membership_state: membershipState,
      } = sessionData;
      setUserData({
        loggedIn,
        isMember,
        membershipType,
        activeCredits,
        userId,
        nextCreditDate,
        firstName,
        lastName,
        userEmail,
        fetched: true,
        membershipState,
      });

      ewAnalytics.setUserInfo({
        loggedIn,
        isMember,
        id: userId,
      });

      ldClient?.identify({
        key: 'guest',
        anonymous: true,
      });
    } catch (e) {
      setUserData({
        ...defaultUser,
        fetched: true,
      });

      ldClient?.identify({
        key: 'guest',
        anonymous: true,
      });
    }
  };

  useEffect(() => {
    if (userData.fetched === false) {
      try {
        runEffect();
      } catch (err: any) {
        logError(err, undefined, 'custom');
      }
    }
  }, []);

  return {
    userData,
    runEffect,
  };
};

export default useUserContext;
